import React from "react";
import { useForm } from "react-hook-form";
import { withTranslation } from "react-i18next";
import { COUNTRY_OPTION, EXCHANGE_RATE_TYPE } from "../../constant";

const defaultOption = {
  value: "",
  label: "All"
};

const defaultFormValue = {
  country: defaultOption.value,
  rate_type: defaultOption.value,
  show_only_enable_label: false,
}

function ExchangeRateSearchForm({ onClickSearch, isLoading }) {
  const countryOptions = [defaultOption, ...COUNTRY_OPTION];
  const rateTypeOptions = [
    defaultOption,
    { value: "GENERIC", label: EXCHANGE_RATE_TYPE.GENERIC },
    { value: "NEW_CUSTOMER", label: EXCHANGE_RATE_TYPE.NEW_CUSTOMER },
    { value: "SPECIAL_TRANSACTION", label: EXCHANGE_RATE_TYPE.SPECIAL_TRANSACTION },
    { value: "SPECIAL_CUSTOMER", label: EXCHANGE_RATE_TYPE.SPECIAL_CUSTOMER },
  ];

  const {
    reset,
    register,
    handleSubmit,
  } = useForm({
    defaultValues: defaultFormValue,
    mode: "onChange"
  });

  function onSubmitHandler(formValue) {
    onClickSearch(formValue);
  }

  function mapOptions(options) {
    return options.map(o => (
      <option key={o.value} value={o.value}>{o.label}</option>
    ));
  }

  return (
    <div className="card card-secondary">
      <div className="card-header">
        <h6>Remittance Configuration - Customer Rate</h6>
      </div>

      <form
        onSubmit={handleSubmit(onSubmitHandler)}
        data-testid="exchange-form"
      >
        <div className="p-4">
          <div className="row">
            <div className="offset-md-3 col-sm-5">
              <div className="form-group row">
                <label className="col-form-label col-sm-5 text-lg-right">
                  Country
                </label>
                <div className="col-sm-7 p-0">
                  <select
                    className="form-control"
                    data-testid="select-country"
                    {...register("country")}
                  >
                    {mapOptions(countryOptions)}
                  </select>
                </div>
              </div>
              <div className="form-group row">
                <label className="col-form-label col-sm-5 text-lg-right">
                  Rate Type
                </label>
                <div className="col-sm-7 p-0">
                  <select
                    className="form-control"
                    data-testid="select-rate-type"
                    {...register("rate_type")}
                  >
                    {mapOptions(rateTypeOptions)}
                  </select>
                </div>
              </div>
              <div className="form-group row mb-4">
                <label className="col-form-label col-sm-5 text-lg-right">
                </label>
                <div className="col-sm-7 p-0">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="show-only-enabled-labels"
                      data-testid="select-show-only-enable-label"
                      {...register("show_only_enable_label")}
                    />
                    <label className="form-check-label" htmlFor="show-only-enabled-labels">
                      Show only enabled labels
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <button
              type="submit"
              data-testid="exchange-rate-search-button"
              className="btn btn-warning"
              disabled={isLoading}
            >
              Search
            </button>
            <button
              type="button"
              data-testid="exchange-rate-clear-form-button"
              className="btn btn-secondary ml-1"
              disabled={isLoading}
              onClick={() => reset()}
            >
              Clear
            </button>
          </div>
        </div>
      </form>
    </div>
  );

}

export default withTranslation()(ExchangeRateSearchForm);
